export default {
    data() {
        return {
            isSending: false,
            isSent: false,
            error: {},
        }
    },

    computed: {
        stopProcessingAfterRequestFinished() {
            return false
        },
    },

    methods: {
        triggerAutofocusInput() {
            if (this.focusAutofocusInput) {
                this.focusAutofocusInput()
            }
        },

        triggerAutoScrollError() {
            const errorsInput = document.querySelectorAll('.form-field__error')

            if (errorsInput && errorsInput[0]?.previousElementSibling) {
                errorsInput[0].previousElementSibling.scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                    inline: 'center',
                })
            }
        },

        handleRequest(promise) {
            this.isSending = true
            this.isSent = false

            return (Array.isArray(promise) ? Promise.all(promise) : promise)
                .then((response) => {
                    if (this.stopProcessingAfterRequestFinished) {
                        this.isSending = false
                        this.isSent = true
                        this.$validation.clear()
                    }

                    return response
                })
                .catch((error) => {
                    this.error = error.response
                    this.isSending = false
                    this.triggerAutoScrollError()
                    return Promise.reject(error)
                })
        },
    },

    mounted() {
        this.triggerAutofocusInput()
        this.$validation.clear()
    },
}
